import { FilterState } from '@Component/Filter/utils.ts';
import { OverviewDisplayOptions } from '@Page/Overview/DisplayOptions';
import { OverviewFilters } from '@Page/Overview/OverviewFilters';
import { TableTopBar } from '@tlx/atlas';

export function OverviewTopBar(filters: FilterState) {
    return (
        <TableTopBar>
            <OverviewFilters filterState={filters} />
            <OverviewDisplayOptions />
        </TableTopBar>
    );
}
